<template>
	<v-container>
		<div id="flexContainer" ref="flexContainer" class="d-flex flex-row" :style="{
			overflowY: (expanded ? 'visible' : 'hidden'),
			maxHeight: (expanded ? '' : '60px')
		}">
			<span class="align-self-start mr-2 mt-1 consistentText" style="white-space: nowrap;">
				{{ Translate('Selected') }} {{typeDescriptor}}:
			</span>
            
            <draggable 
                v-model="internalPills" 
                class="d-flex flex-row flex-wrap align-content-start" 
                style="flex: 1; gap: 6px;"
                :animation="200"
                ghost-class="ghost-pill"
            >
                <v-chip
					v-for="item in internalPills"
					:key="item.id || item.ColId || item.colId || item.headerName"
					@click:close="removePill(item)"
					close
                    pill
                    text-color="primary"
                    class="pill ma-0"
					close-icon="mdi-close"
                    style="grab"
                    color="primaryLighten2"
				>
					<template v-if="item.calculation && item.calculation !== 'bucket'">
						{{ formatHeader({ type: item.SourceType, headerName: item.Title, aggFunc: item.calculation }) }}
					</template>
					<template v-else>
						{{ item.headerName || item.Name || item.Title }}
					</template>
				</v-chip>
            </draggable>
		</div>
        <div role="button" v-if="expanded" @click="toggleExpansion()" class="align-self-start ml-2 mt-1 consistentText" style="text-decoration: underline; white-space: nowrap;">
            {{ Translate('Hide') }}
        </div>
		<div role="button" class="consistentText" style="text-decoration: underline;" v-if="hasMorePills && !expanded" @click="toggleExpansion()">
			{{ Translate('Show all') }}
		</div>
	</v-container>
</template>

<script>
import Vue from "vue";
import common from './common.js';
import methods from '@/Shared/methods';
import draggable from "vuedraggable";

export default {
    components: { draggable },
	props: {
		removePill: null,
		pills: Array,
		typeDescriptor: null
	},
	data() {
		return {
			expanded: false,
            hasMorePills: false,
            formatHeader: common.formatHeader,
		};
	},
	mounted() {
		Vue.nextTick(() => {
			this.checkOverflow();
		})
	},
	watch: {
		pills: {
			handler() {
				this.checkOverflow();
			},
			deep: true,
		}
	},
    computed: {
        internalPills: {
            get() {
                return this.pills;
            },
            set(val) {
                this.$emit('reorder', val);
            }
        }
    },
	methods: {
		...methods,
		checkOverflow() {
			Vue.nextTick(() => {
				const container = this.$refs.flexContainer;
				const scrollHeight = container.scrollHeight;
				const clientHeight = container.clientHeight;
				this.hasMorePills = scrollHeight > clientHeight;
			});
		},
		toggleExpansion() {
			this.expanded = !this.expanded;
            this.checkOverflow();
		},
	},
};
</script>

<style scoped>
.pill {
    border: 1px solid var(--v-primary-base) !important;
    background-color: var(--v-cyan-base) !important;
}
.pill::before {
    display: none;
}
.consistentText {
	color: var(--v-black-base) !important; 
	opacity: 0.8 !important; 
	font-size: 14px !important; 
	text-rendering: optimizelegibility !important; 
	letter-spacing:0.1 !important;
}
/* Optional: slightly dims the pill you are currently dragging */
.ghost-pill {
    opacity: 0.4; 
}
</style>